import { render, staticRenderFns } from "./FileQuestion.vue?vue&type=template&id=5af88ae5&scoped=true&"
import script from "./FileQuestion.vue?vue&type=script&lang=js&"
export * from "./FileQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FileQuestion.vue?vue&type=style&index=0&id=5af88ae5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af88ae5",
  null
  
)

export default component.exports